// extracted by mini-css-extract-plugin
export var standaloneTable = "_hf-0";
export var standaloneTableWithBodyFill = "_hf-1";
export var withExtraHeader = "_hf-2";